module.exports = __webpack_public_path__ + "img/formSection_img.e754ff7a.png";